import { useContext, useEffect, useState } from "react";
import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import moment from "moment";
import TenantContext from "../../context/tenant/TenantContext";
import { useNavigate } from "react-router-dom";
import constants from "../../Utils/constants";
import AuthContext from "../../context/auth/AuthContext";
import DatePicker from "react-datepicker";

const ReviewAssignProp = (props) => {
  const tenantContext = useContext(TenantContext);
  const { checkUelzStatus } = tenantContext;
  const authContext = useContext(AuthContext);
  const { setLoading } = authContext;
  const { formData, handleNextStep } = props;
  const landlordName = `${
    haveValue(formData?.landlord_id?.fname_companyName)
      ? formData?.landlord_id?.fname_companyName
      : ""
  } ${
    haveValue(formData?.landlord_id?.lname) ? formData?.landlord_id?.lname : ""
  }`;
  const tenantName = `${
    haveValue(formData?.tenant_id?.fname) ? formData?.tenant_id?.fname : ""
  } ${haveValue(formData?.tenant_id?.lname) ? formData?.tenant_id?.lname : ""}`;
  const propAddr = `${formData?.property_id?.street} - ${formData?.property_id?.street_number}, ${formData?.property_id?.floor_number}-${formData?.property_id?.flat_number}`;

  const [editDate, setEditDate] = useState(false);
  const [payment_date, setPaymentDate] = useState(formData?.payment_date);
  const [ie_verified, setie_verified] = useState(false);
  const [ieScore, setIeScore] = useState(0);

  const navigate = useNavigate();

  const { _t } = useTranslator();

  const handleKeyDown = (event) => {
    event.preventDefault();
  };

  const checkIeDetails = (userDetails) => {
    var check = false;

    setie_verified(check);
  };

  useEffect(() => {
    checkIeDetails(formData?.tenant_id);
  }, [formData]);
  useEffect(() => {
    calculateIeScore();
  }, [ie_verified, formData]);
  const calculateIeScore = () => {
    var totalScore =
      (formData?.tenant_id?.paymentScores?.creditScore?.value || 0) / 2;

    if (ie_verified) {
      if (totalScore >= 600) {
        totalScore += 200;
      } else {
        totalScore += 400;
      }
    }
    if (totalScore > 850) {
      totalScore = 850;
    }
    setIeScore(totalScore);
  };

  const calculatePaymentDate = (date) => {
    const todayDate = new Date();
    var currentYear = todayDate.getFullYear();
    var currentMonth = todayDate.getMonth();
    var currPayDay = new Date(currentYear, currentMonth, date);

    if (
      currPayDay < todayDate ||
      currPayDay < new Date(formData?.payment_start)
    ) {
      while (
        currPayDay < todayDate ||
        currPayDay < new Date(formData?.payment_start)
      ) {
        currentMonth++;

        if (currentMonth > 11) {
          currentMonth = 0; // January
          currentYear++;
        }
        currPayDay = new Date(currentYear, currentMonth, date);
      }

      return currPayDay.toLocaleDateString("en-GB");
    } else {
      return currPayDay.toLocaleDateString("en-GB");
    }
  };

  const checkSuccessPayload = () => {
    setLoading(true);
    checkUelzStatus(formData?._id)
      .then((res) => {
        if (res?.success_res?.data?.status == constants.COMPLETED) {
          setLoading(false);
          navigate(`/awarded/property/${formData?._id}?confirmation=true`);
        } else {
          checkSuccessPayload();
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <>
      <div className="reviewandconform uiux mobile-review-box">
        <div className="reviewandconform-body  ">
          <h3>{_t("review")}</h3>

          <div className="payment-body">
            <div className="row">
              <div className="col-sm-6 mobile-review-filed">
                <h6>{_t("moveInAddress")}</h6>
                <p>{propAddr}</p>
              </div>
              <div className="col-sm-6 mobile-review-filed">
                <h6>{_t("landlord")}</h6>
                <p>{landlordName}</p>
              </div>
              <div className="col-sm-12 mobile-review-filed">
                <h6> {_t("tenant")} </h6>
                <p>{tenantName}</p>
                <p>
                  Skor:{" "}
                  {haveValue(
                    formData?.tenant_id?.gurantor_id?.paymentScores?.creditScore
                      ?.value,
                  )
                    ? formData?.tenant_id?.gurantor_id?.paymentScores
                        ?.creditScore?.value
                    : formData?.tenant_id?.paymentScores?.creditScore
                        ?.value}{" "}
                </p>
              </div>
              <div className="col-sm-6 mobile-review-filed">
                <h6>{_t("leaseStartDate")}</h6>
                <p>
                  {new Date(formData?.payment_start).toLocaleDateString(
                    "en-GB",
                  )}
                </p>
              </div>
              <div className="col-sm-6 mobile-review-filed">
                <h6>{_t("leaseEndDate")}</h6>
                <p>
                  {haveValue(formData?.lease_end)
                    ? new Date(formData?.lease_end).toLocaleDateString("en-GB")
                    : _t("open")}
                </p>
              </div>
              <div className="col-sm-12 mobile-review-filed">
                <h6> {_t("isItAShardHouseHold")} </h6>
                <p className="text-capitalize">{formData?.shared_household}</p>
              </div>
              <div className="col-sm-6 mobile-review-filed">
                <h6>{_t("rentalPaymentAmount")}</h6>
                <p>{formData?.rent_amount}</p>
              </div>
              <div className="col-sm-6 mobile-review-filed">
                <h6>{_t("depositAmount")}</h6>
                <p>{formData?.deposit_amount}</p>
              </div>
              <div className="col-sm-12 mobile-review-filed ">
                <h6 className="date-payment">
                  {_t("paymentDate")}
                  <span>*</span>
                </h6>
                {editDate ? (
                  <div className="native-like-datepicker">
                    <DatePicker
                      className="choose-date date-input cursor-pointer"
                      selected={
                        payment_date
                          ? moment(
                              calculatePaymentDate(payment_date),
                              "DD/MM/YYYY",
                            ).toDate()
                          : null
                      }
                      onKeyDown={handleKeyDown}
                      onChange={(date) => {
                        if (!date) return;

                        // ✅ normalize (avoid timezone issue)
                        const localDate = new Date(
                          date.getFullYear(),
                          date.getMonth(),
                          date.getDate(),
                        );

                        // same behavior as before
                        setPaymentDate(localDate.getDate());
                      }}
                      dateFormat="dd/MM/yyyy"
                      /* ✅ FIX: must be Date objects */
                      minDate={moment(
                        calculatePaymentDate("1"),
                        "DD/MM/YYYY",
                      ).toDate()}
                      maxDate={moment(
                        calculatePaymentDate("5"),
                        "DD/MM/YYYY",
                      ).toDate()}
                      placeholderText="dd/mm/yyyy"
                      showPopperArrow={false}
                      popperPlacement="bottom-start"
                    />
                    <span className="calendar-icon cursor-pointer">
                      <img
                        src="/images/calendar-icon.svg"
                        alt="Calendar Icon"
                      />
                    </span>
                  </div>
                ) : (
                  <>
                    <p>{calculatePaymentDate(formData?.payment_date)}</p>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="payment-detail-content">
            <p>
              {" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM13.712 6.72339C13.3207 7.09299 12.85 7.27778 12.3 7.27778C11.7473 7.2803 11.2763 7.0955 10.887 6.72339C10.4977 6.35128 10.302 5.90645 10.3 5.38889C10.298 4.87134 10.4937 4.42682 10.887 4.05534C11.2803 3.68386 11.7513 3.49875 12.3 3.50001C12.8487 3.50127 13.3193 3.68638 13.712 4.05534C14.1047 4.4243 14.3007 4.86882 14.3 5.38889C14.2993 5.90897 14.1033 6.3538 13.712 6.72339ZM13.8 9.16667V20.5H10.8V9.16667H13.8Z"
                  fill="#07569E"
                ></path>
              </svg>{" "}
              <span>{_t("directlyContactYourLandlordInCaseOfMistakes")}.</span>
            </p>
          </div>
          <button onClick={(e) => handleNextStep()} className="btn btngreen">
            {_t("confirmAndSetUpPayment")}
          </button>
        </div>
      </div>
    </>
  );
};

export default ReviewAssignProp;
